const trimForwardSlash: (s: string) => string = (s: string) => {
  if (s.startsWith('/')) return trimForwardSlash(s.substring(1));
  return s;
};

const createUrl = (url: string) => {
  let newUrl = trimForwardSlash(url);
  newUrl = newUrl.startsWith('http://') || newUrl.startsWith('https://') ? newUrl : `https://${newUrl}`;
  return newUrl;
};

export default createUrl;
